import { PreguntaCargaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaMultipleImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.MULTIPLE_CHOICE;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.minimoItemsSeleccionados = preguntaPadre.minimo ?? 0;
        preguntaPadre.maximoItemsSeleccionados = preguntaPadre.maximo ?? 0;
        preguntaPadre.minimo = null;
        preguntaPadre.maximo = null;

        return preguntas;
    }
}
